import { useEffect, useState } from 'react';


const Mensaje = ({ errorMessage, tiempo  }) => {
  const [showError, setShowError] = useState(true);

  useEffect(() => {
    if (errorMessage) {
      setTimeout(() => {
        setShowError(false);
      }, tiempo); // Ocultar el mensaje después del tiempo que le indiques
    }
  }, [errorMessage,tiempo]);

  return (
    <div className="error-message verde pt-2" style={{ display: showError ? 'block' : 'none' }}>
      {errorMessage}
    </div>
  );
};

export default Mensaje